import { SearchOutlined } from "@ant-design/icons";
import { Input, InputRef } from "antd";
import styled from "styled-components";
import { SharedButton } from "../shared";
import { useTranslation } from "react-i18next";
import { ChangeEvent, KeyboardEventHandler, useRef, useState } from "react";
import { useNotify } from "@utils";
const iconHeight = { fontSize: 25, color: "#6E6893" };

interface IProps {
  inputPlaceholder: string;
  searchInput: (value: string) => void;
}
export const Search = ({ inputPlaceholder, searchInput }: IProps) => {
  const { t } = useTranslation();
  const { warning } = useNotify();
  const input = useRef<InputRef>(null);
  const [text, setText] = useState<string>("");
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };
  const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };
  const handleSearch = () => {
    if (text) {
      searchInput(text);
    } else {
      input.current?.focus();
      warning(t("message.warning.type"));
    }
  };
  return (
    <StyledSearch>
      <Input
        size="large"
        ref={input}
        placeholder={inputPlaceholder}
        prefix={<SearchOutlined style={iconHeight} />}
        onChange={handleChange}
        onKeyUp={handleKeyUp}
      />
      <SharedButton type="primary" size="middle" onClick={handleSearch}>
        {t("page.search")}
      </SharedButton>
    </StyledSearch>
  );
};

const StyledSearch = styled.div`
  display: flex;
  column-gap: 20px;
  flex: 1;
  .ant-input-affix-wrapper {
    max-width: 443px;
    border-radius: 6px;
    .ant-input {
      color: ${(p) => p.theme.colors.search};
      &::placeholder {
        color: ${(p) => p.theme.colors.search};
      }
    }
  }
`;
